import client from '@/plugins/axios.js'

export default  {
    customerList(){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/crm/customers')
                .then((res)=>{
                    resolve(res.data?.data?.primaryObject)
                })
                .catch((err)=>{
                    reject(err)
                })
        });
    },
    customer(id){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/crm/customer/'+id)
                .then((res)=>{
                  resolve(res.data?.data[0])
                })
                .catch((err)=>{
                  console.log("Error calling api/crm/customer:",err)
                  reject(err)
                })
        });
    },
    orderlist(id){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/order/custlist/'+id)
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                  console.log("Error calling api/order/custlist",err)
                    reject(err)
                })
        });
    },
    addCustomer(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/crm/customer/add', payload)
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                  console.log("Error calling api/crm/customer/add",err)
                    reject(err)
                })
        });
    },
    setDirectDeliveryCust(custlistId, isDirectDelivery){
        return new Promise((resolve,reject)=>{
          client({requiresAuth:true}).post('/api/crm/customer/'+custlistId+'/direct-delivery', {
            isDirectDelivery:isDirectDelivery
          })
            .then((res)=>{
              resolve(res.data.data)
            })
            .catch((err)=>{
              console.log("Error calling /api/crm/customer/direct-delivery",err)
              reject(err)
            })
        });
    },
  saveCustomer(id, payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/crm/customer/'+id, payload)
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                  console.log("Error calling /api/crm/customer/",err)
                    reject(err)
                })
        });
    },
    addTag(customerId, tagId){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post(`/api/crm/customer/${customerId}/tag/${tagId}/add`)
                .then(res => {
                    resolve(res.data?.data?.primaryObject)
                })
                .catch(err => {
                  console.log("Error calling api/crm/customer/tag/add",err)
                    reject(err)
                })
        });
    },
    removeTag(customerId, tagId){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post(`/api/crm/customer/${customerId}/tag/${tagId}/remove`)
                .then(res => {
                    resolve(res.data?.data?.primaryObject)
                })
                .catch((err)=>{
                  console.log("Error calling api/crm/customer/tag/remove",err)
                    reject(err)
                })
        });
    },
    createTag(tagName){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post(`/api/crm/addTag`, {tagName})
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    console.log(err)
                    reject(err)
                })
        });
    },
    mergeCustomers({current, target}){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post(`/api/crm/customer/${current}/mergeinto/${target}`)
                .then((res)=>{
                    console.log("customer merge success:", res,res.data.data)
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    console.log("customer merge failed:", err)
                    reject(err)
                })
        });
    },
    sendMessageToCustomers({customerIds, content, subject, options}){
        // customerIds: Array
        // content: String
        // options: {sms: true, email: false}
        let selectedOptions = {}
        if(options == 'sms'){
            selectedOptions =  {sms: true, email: false}
        } else {
            selectedOptions =  {sms: false, email: true}
        }

        let payload = { customerIds, content, options:selectedOptions }
        if(options == 'email'){
            payload.subject = subject
        }
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post(`/api/crm/sendMessage`, payload)
                .then((res)=>{
                    console.log("send SMS success:", res,res.data.data)
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    console.log("send SMS failed:", err)
                    reject(err)
                })
        })
    },
    deleteCustomer(customerId){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post(`/api/crm/customer/${customerId}/delete`)
                .then(() => {
                    resolve()
                })
                .catch(err => {
                    reject(err)
                })
        });
    },



}
